import { BarcodeLink } from "./BarcodeLinkStyles";
import {
  binInventoryLink,
  containerInventoryLink,
} from "../../../../utils/links/inventory";
import React from "react";

export function ContainerLink({
  containerBarcode,
}: {
  containerBarcode: string;
}) {
  return (
    <BarcodeLink
      href={containerInventoryLink(containerBarcode)}
      target={"_blank"}
    >
      {containerBarcode}
    </BarcodeLink>
  );
}

export function BinLink({ binBarcode }: { binBarcode: string }) {
  return (
    <BarcodeLink href={binInventoryLink(binBarcode)} target={"_blank"}>
      {binBarcode}
    </BarcodeLink>
  );
}
